import { render, staticRenderFns } from "./DispatchPatternEdit.vue?vue&type=template&id=032a8a0c&scoped=true&lang=pug"
import script from "./DispatchPatternEdit.vue?vue&type=script&lang=js"
export * from "./DispatchPatternEdit.vue?vue&type=script&lang=js"
import style0 from "./DispatchPatternEdit.vue?vue&type=style&index=0&id=032a8a0c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032a8a0c",
  null
  
)

export default component.exports